import { render } from "./ShipToSelect.vue?vue&type=template&id=2c31c3b1&scoped=true"
import script from "./ShipToSelect.vue?vue&type=script&lang=js"
export * from "./ShipToSelect.vue?vue&type=script&lang=js"

import "./ShipToSelect.vue?vue&type=style&index=0&id=2c31c3b1&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c31c3b1"]])

export default __exports__